// src/components/HomeHeader.js
import React, { useEffect, useState } from 'react';
import {
  Typography,
  Row,
  Col,
  Card,
  Button,
  Layout,
  Dropdown,
  Menu,
} from 'antd';
import { UserOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import { jwtDecode } from 'jwt-decode'; // Importación corregida
import { useNavigate } from 'react-router-dom';

// Importamos el logo
import logo from '../assets/smb-logo.png'; // Asegúrate de que la ruta sea correcta

const { Header } = Layout;

function HomeHeader({ authToken }) {
  const [dateTime, setDateTime] = useState('');
  const [remainingTime, setRemainingTime] = useState('');
  const [username, setUsername] = useState('Usuario');
  const navigate = useNavigate();

  useEffect(() => {
    if (authToken) {
      const decoded = jwtDecode(authToken); // Uso de jwtDecode en lugar de jwt_decode
      setUsername(decoded.usuario);
    }
  }, [authToken]);

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      setDateTime(now.toLocaleString());
    };

    updateDateTime();
    const intervalId = setInterval(updateDateTime, 1000);

    return () => clearInterval(intervalId);
  }, []);

  // Función para obtener el próximo jueves a las 11:59:59 PM
  const getNextThursday = () => {
    const now = new Date();
    const resultDate = new Date(now);
    resultDate.setHours(23, 59, 59, 999); // Establecer la hora a las 11:59:59 PM

    const dayOfWeek = resultDate.getDay(); // 0 (Domingo) a 6 (Sábado)
    const daysUntilThursday = ((4 - dayOfWeek + 7) % 7) || 7; // Días hasta el próximo jueves

    resultDate.setDate(resultDate.getDate() + daysUntilThursday);

    return resultDate;
  };

  useEffect(() => {
    let deadline = getNextThursday();

    const updateRemainingTime = () => {
      const now = new Date();
      if (now > deadline) {
        // Si la fecha actual ha pasado el deadline, calcular el próximo jueves
        deadline = getNextThursday();
      }
      const timeDiff = deadline - now;

      if (timeDiff > 0) {
        const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
        const seconds = Math.floor((timeDiff / 1000) % 60);

        setRemainingTime(`${days}d ${hours}h ${minutes}m ${seconds}s`);
      } else {
        // El tiempo ha expirado, actualizar al próximo jueves
        deadline = getNextThursday();
        setRemainingTime('El tiempo ha expirado.');
      }
    };

    updateRemainingTime();
    const intervalId = setInterval(updateRemainingTime, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const Navigate = (path) => {
    navigate(path);
  }

  // Menú desplegable para el usuario
  // const menu = (
  //   // <Menu>
  //   //   <Menu.Item key="logout" onClick={() => Navigate("/settings-auth")} icon={<SettingOutlined />}>
  //   //     Config. autorización
  //   //   </Menu.Item>
  //   //   <Menu.Item key="logout" onClick={onLogout} icon={<LogoutOutlined />}>
  //   //     Cerrar sesión
  //   //   </Menu.Item>
  //   // </Menu>
  // );

  return (
    <div>
      {/* <Header style={{ background: '#fff', padding: '0 16px' }}> */}
        {/* Logo en el lado izquierdo */}
        {/* <div style={{ float: 'left' }}>
          <img src={logo} alt="SMB Logo" style={{ height: '40px' }} />
        </div> */}

        {/* Menú de usuario en el lado derecho */}
        {/* <div style={{ float: 'right' }}>
          <Dropdown overlay={menu} trigger={['click']}>
            <Button type="text" icon={<UserOutlined />}>
              Hola, {username}
            </Button>
          </Dropdown>
        </div>
      </Header> */}

      {/* Limpiar flotación */}
      <div style={{ clear: 'both' }} />

      <div style={{ textAlign: 'center', marginBottom: 20 }}>
        <Row justify="center" gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12}>
            <Card>
              <Typography.Title level={5} style={{marginTop:0}}>Hora y fecha actual</Typography.Title>
              <Typography.Text>{dateTime}</Typography.Text>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={12}>
            <Card>
              <Typography.Title level={5} style={{marginTop:0}}>
                Fecha límite para añadir pagos
              </Typography.Title>
              <Typography.Text>{remainingTime}</Typography.Text>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default HomeHeader;
